import { Skeleton } from '../ui/skeleton.js';
import { TableCell, TableRow } from '../ui/table.js';

export interface DataTableSkeletonProps {
  columnCount: number;
  rowCount?: number;
}

/**
 * Placeholder rows matching the real row height and column count, so the table does not
 * change height when data arrives and the page stops jumping under the cursor.
 */
export function DataTableSkeleton({ columnCount, rowCount = 8 }: DataTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: placeholder rows have no identity and are never reordered
        <TableRow key={rowIndex} aria-hidden="true">
          {Array.from({ length: columnCount }, (_, colIndex) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: as above
            <TableCell key={colIndex}>
              <Skeleton className="h-4 w-full max-w-[16ch]" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
